<template>
  <div v-if="hasCustomLeagueLogo">
    <img class="block object-cover" :src="`/league-logos/${slug}.png`">
  </div>
</template>

<script setup>
import customLeagueLogos from '@/data/custom-league-logos.js'

const props = defineProps({ 
  name: String, 
  slug: String,
})

const hasCustomLeagueLogo = computed(() => customLeagueLogos.includes(props.slug))
</script>
